import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { ProductOption_Fragment } from "./product-option";
// import { ProductVariant_Fragment } from "./product-variant";
// import { SellingPlanGroup_Fragment } from "./selling-plan-group";
// import { MediaConnectionMasked_Fragment } from "./media-connection";

export const ProductWithVariants_Fragment = graphqlShopifyStorefront(
  `
  fragment ProductWithVariants on Product {
    availableForSale
    collectionsConnectionMasked: collections(first: $collectionsFirst) {
      edges {
        node {
          id
          handle
          title
        }
      }
    }
    compareAtPriceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    description
    descriptionHtml
    handle
    id
    mediaConnectionMasked: media(first: 8) {
      ...MediaConnectionMasked
    }
    optionsMasked: options(first: 16) {
      ...ProductOption
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    requiresSellingPlan
    sellingPlanGroupsConnectionMasked: sellingPlanGroups(first:1) {
      edges {
        node {
          ...SellingPlanGroup
        }
      }
    }
    seo {
      description
      title
    }
    tags
    title
    updatedAt
    variantsConnectionMasked: variants(first: 64) {
      edges {
        node {
          ...ProductVariant
        }
      }
    }
    vendor
  }
`,
  // [
  //   MediaConnectionMasked_Fragment,
  //   ProductOption_Fragment,
  //   ProductVariant_Fragment,
  //   SellingPlanGroup_Fragment,
  // ],
);
